<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="listPage()"
    />&nbsp; Post A Video
  </div>

  <div class="example-header">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="fulllwidth">
            <mat-form-field>
              <input
                type="text"
                required
                matInput
                placeholder="Title"
                formControlName="Title"
              />
              <mat-error *ngIf="form.get('Title').hasError('required')">
                Please Enter Title.
              </mat-error>
            </mat-form-field>
            <div>
              <span>
                <mat-form-field appearance="fill" style="width: 48%">
                  <mat-label>Choose a date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="PublishDate"
                    [max]="getToday()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </span>
              &nbsp;&nbsp;
              <span>
                <mat-form-field appearance="fill" style="width: 48%">
                  <mat-label>Source</mat-label>
                  <input
                    type="text"
                    required
                    matInput
                    placeholder="Source"
                    formControlName="Source"
                  />
                  <mat-error *ngIf="form.get('Source').hasError('required')">
                    Please Enter source.
                  </mat-error>
                </mat-form-field>
              </span>
            </div>

            <mat-form-field>
              <textarea
                matInput
                required
                maxlength="500"
                rows="5"
                style="height: 50px; resize: none !important"
                placeholder="Description"
                formControlName="Description"
              ></textarea>
              <mat-error *ngIf="form.get('Description').hasError('required')">
                Please Enter Description.
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Languages</mat-label>
              <mat-select formControlName="languages" required>
                <mat-option
                  *ngFor="let language of languageList"
                  [value]="language?.value"
                >
                  {{ language?.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div>
              <span>
                <mat-form-field style="width: 68%">
                  <mat-select
                    placeholder="Category"
                    formControlName="CategoryID"
                  >
                    <mat-option
                      *ngFor="let opt of categorydatalist"
                      (click)="getcategory(opt.categoryId)"
                      [value]="opt.categoryId"
                    >
                      <img with="20" height="20" [src]="opt.image" />
                      {{ opt.categoryName }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="form.get('CategoryID').hasError('required')"
                  >
                    Please select Category.
                  </mat-error> </mat-form-field
                >&nbsp;&nbsp;

                <button
                  type="button"
                  class="add_button_new"
                  mat-raised-button
                  color="primary"
                  (click)="mangeCategory()"
                >
                  Manage Categories</button
                >&nbsp;
              </span>
            </div>
            <mat-form-field>
              <input
                type="text"
                formControlName="VideoURL"
                placeholder="Video URL On YouTube"
                matInput
              />
              <mat-error *ngIf="form.get('VideoURL').hasError('required')">
                Please Enter VideoURL.
              </mat-error>
            </mat-form-field>
            <div class="row">
              <div class="col-12" style="margin-bottom: 10px"></div>

              <div class="col-md-12">
                <button
                  class="pull-right submitBtn"
                  mat-button
                  type="submit"
                  [disable]="disable"
                >
                  Post
                </button>
              </div>
            </div>
            <!-- <div *ngIf="requirederror">Please Enter Mandatory Fields</div> -->
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
